export default {
  path: 'partner-locations',
  name: 'PartnerLocations',
  component: () => import(/* webpackChunkName: "administration" */ '../views/PartnerLocationsView.vue'),
  meta: {
    exact: true,
    requiresAuth: true
  }
}
